<template>
  <!-- 如果沒傳 id，就用 target，否則用傳進來的 id -->
  <a class="accesskey" :id="id || target" :href="href || '#'" :accesskey="accesskey" :aria-label="ariaLabel"
    @click.prevent="scrollToTarget">
    <slot />
  </a>

</template>

<script>
import { String } from 'core-js';


export default {
  props: {
    id: { type: String, default: '' },   // 元素 id
    target: { type: String, required: true },   // scroll/focus 目標
    offset: { type: Number, default: 0 },
    accesskey: { type: String, default: '' },
    ariaLabel: { type: String, default: '' },
    href: { type: String, default: '#' },   // 加入 href prop，預設 #，保證可 tab
  },
  methods: {
    scrollToTarget(event) {
      if (event) event.preventDefault()

      const targetEl = document.getElementById(this.target)
      if (!targetEl) return

      // 讓元素可 focus
      if (!targetEl.hasAttribute('tabindex')) {
        targetEl.setAttribute('tabindex', '-1')
      }

      targetEl.focus()

      // 平滑捲動到目標位置
      window.scrollTo({
        top: targetEl.offsetTop + this.offset,
        behavior: 'smooth'
      })
    }
  }

}
</script>